import React from "react";

const Bathrooms = () => {
  return (
    <svg
      width="18"
      height="19"
      viewBox="0 0 18 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.1292 3.14374C11.0466 3.14374 10.1661 4.02425 10.1661 5.10687V5.78034C10.1661 6.07756 10.4071 6.31853 10.7043 6.31853C11.0015 6.31853 11.2425 6.07756 11.2425 5.78034V5.10687C11.2425 4.61805 11.6404 4.22011 12.1292 4.22011C12.618 4.22011 13.016 4.61805 13.016 5.10687V9.97511H3.33698C3.03976 9.97511 2.79879 10.2161 2.79879 10.5133C2.79879 12.1704 3.79677 13.5978 5.22243 14.2277C5.00145 14.5322 4.87057 14.9099 4.87057 15.318C4.87057 15.6153 5.11154 15.8562 5.40876 15.8562C5.70597 15.8562 5.94694 15.6153 5.94694 15.318C5.94694 14.8964 6.26633 14.5719 6.63625 14.5719H11.3638C11.7337 14.5719 12.0531 14.8964 12.0531 15.318C12.0531 15.6153 12.2941 15.8562 12.5913 15.8562C12.8885 15.8562 13.1295 15.6153 13.1295 15.318C13.1295 14.9099 12.9986 14.5322 12.7776 14.2277C14.2032 13.5978 15.2012 12.1704 15.2012 10.5133C15.2012 10.2161 14.9602 9.97514 14.663 9.97514H14.0924V5.10687C14.0924 4.02424 13.2118 3.14374 12.1292 3.14374ZM6.85746 13.4956C5.39694 13.4956 4.17781 12.4399 3.9238 11.0515H14.0762C13.8222 12.4399 12.603 13.4956 11.1425 13.4956H6.85746Z"
        fill="#363C4B"
      />
      <path
        d="M10.7043 7.18456C10.4071 7.18456 10.1661 7.42553 10.1661 7.72275V8.04293C10.1661 8.34015 10.4071 8.58112 10.7043 8.58112C11.0015 8.58112 11.2425 8.34015 11.2425 8.04293V7.72273C11.2424 7.42551 11.0015 7.18456 10.7043 7.18456Z"
        fill="#363C4B"
      />
    </svg>
  );
};

export default Bathrooms;
